<footer class="admin-page-footer">
  <span>&copy; {{ year }} GoCareMo. All rights reserved.</span>
  <span class="footer-sep">|</span>
  <span>v{{ version }}</span>
</footer>
